// Eckbearbeitung der L×B-Fläche: Fase oder Radius je Ecke — in part.meta.corners.
// Schlüssel: vl/vr = vorn links/rechts (z_min), hl/hr = hinten links/rechts (z_max);
// links = x_min. Engine-frei.

export const CORNER_KEYS = ["vl", "vr", "hr", "hl"]
export const CORNER_LABELS = { vl: "Vorn links", vr: "Vorn rechts", hl: "Hinten links", hr: "Hinten rechts" }

const MIN_SIZE = 1

export function cornersOf(part) {
  return part.meta?.corners ?? {}
}

export function maxCornerSize(part) {
  return Math.floor(Math.min(part.length_mm, part.width_mm) / 2) - 1
}

// treatment: { type: "chamfer"|"round", size_mm } oder null zum Entfernen
export function withCorner(part, key, treatment) {
  const corners = { ...cornersOf(part) }
  if (treatment && (treatment.type === "chamfer" || treatment.type === "round")) {
    const size = Number(treatment.size_mm)
    corners[key] = {
      type: treatment.type,
      size_mm: Math.round(Math.min(Math.max(Number.isFinite(size) ? size : 20, MIN_SIZE), maxCornerSize(part)))
    }
  } else {
    delete corners[key]
  }
  const meta = { ...part.meta }
  if (Object.keys(corners).length > 0) meta.corners = corners
  else delete meta.corners
  return meta
}

// Bei schrumpfender Platte alle Ecken auf das neue Maximum klemmen
export function clampCorners(part) {
  const corners = cornersOf(part)
  const max = maxCornerSize(part)
  const clamped = Object.fromEntries(
    Object.entries(corners).map(([key, c]) => [key, { ...c, size_mm: Math.min(c.size_mm, max) }])
  )
  const meta = { ...part.meta }
  if (Object.keys(clamped).length > 0) meta.corners = clamped
  else delete meta.corners
  return meta
}
